import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle
} from '../../../components/ui/alert-dialog'
import type { SourceId } from './types'

type MappingSourceId = Extract<SourceId, 'ipmap' | 'roboticsmap' | 'safetymap' | 'tagmap'>

interface MappingSkipConfirmDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  mappings: MappingSourceId[]
  onConfirm: () => void
}

export function MappingSkipConfirmDialog({
  open,
  onOpenChange,
  mappings,
  onConfirm
}: MappingSkipConfirmDialogProps) {
  const hasIpMap = mappings.includes('ipmap')
  const hasRoboticsMap = mappings.includes('roboticsmap')
  const hasSafetyMap = mappings.includes('safetymap')
  const hasTagMap = mappings.includes('tagmap')

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            {mappings.length === 1
              ? 'Continue without a recommended mapping?'
              : 'Continue without recommended mappings?'}
          </AlertDialogTitle>
          <AlertDialogDescription>
            You can add these mappings later, but ingest will not create their cross-system links.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <ul className="m-0 list-disc space-y-1 pl-5 text-sm text-ink-2">
          {hasIpMap ? (
            <li>PLC programs will not be linked to SCADA devices and OPC servers.</li>
          ) : null}
          {hasRoboticsMap ? <li>Robot I/O signals will not be linked to their PLC tags.</li> : null}
          {hasSafetyMap ? (
            <li>
              SRS functions and equipment will not be linked to Safety Manager FLDs and points.
            </li>
          ) : null}
          {hasTagMap ? (
            <li>SRS equipment tags will not be linked to Experion ControlTags.</li>
          ) : null}
        </ul>
        <AlertDialogFooter>
          <AlertDialogCancel size="sm">Upload a mapping</AlertDialogCancel>
          <AlertDialogAction size="sm" onClick={onConfirm}>
            Continue anyway
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
